import { NgxSpinnerService } from 'ngx-spinner';
import { PreloaderService } from './../_services/Preloader.service';
import { Component, OnInit } from '@angular/core';
import { ToasterService } from './../_services/Toaster.service';
import { DeviceService } from '../_services/_DeviceService/Device.service';
import { Device } from '../_models/Device';
import { ReplaySubject } from 'rxjs';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-Device_Manage',
  templateUrl: './Device_Manage.component.html',
  styleUrls: ['./Device_Manage.component.css']
})
// tslint:disable-next-line: class-name
export class Device_ManageComponent implements OnInit {

  Message: any;
  model: any = {};
  Device: Device[];
  selectedDevice = '';


  constructor(private spinner:NgxSpinnerService, private preloader:PreloaderService, private DeviceService: DeviceService, private noti: ToasterService) { }

  ngOnInit() {

    this.LoadAllDevices();
    this.preloader.hide();
  }
  selectChangeHandler(event: any) {

    this.selectedDevice = event.target.value;
  }
  SetSync() {
    // tslint:disable-next-line: triple-equals
    if (this.selectedDevice == '') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    if (this.selectedDevice == 'Select Device') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }

    try {
      this.spinner.show();
      if(this.selectedDevice=="200")
      {
        this.DeviceService.SetSyncAll().subscribe((Message: any) => {
          this.Message = Message;
          this.spinner.hide();
          this.noti.success('Success', 'Successfully Sync');
        }, error => {
          this.noti.success('Success', 'Successfully Sync');
          this.spinner.hide();
        });
      }
      else
      {

        this.DeviceService.SetSync(this.selectedDevice).subscribe((Message: any) => {
          this.Message = Message;
          this.spinner.hide();
          this.noti.success('Success', 'Successfully Sync');
        }, error => {
          this.noti.success('Success', 'Successfully Sync');
          this.spinner.hide();
        });
      }


    } catch (error) {

      this.spinner.hide();
    }
  }



  ClearLogData() {
    // tslint:disable-next-line: triple-equals
    if (this.selectedDevice == '') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    if (this.selectedDevice == 'Select Device') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    try {
      this.spinner.show();
      this.DeviceService.ClearLogData(this.selectedDevice).subscribe(
        Response => {
          this.spinner.hide();
          if(Response.status==200)
          {
            this.noti.success('Success', 'Successfully Clear');
          }
          else
          {
            this.noti.error('Error', Response.body);
          }


      }, error => {
        this.spinner.hide();
        this.noti.success('Error', error.error);
      });
    } catch (error) {

      this.spinner.hide();
    }

  }
  ResetMachine() {
    if (this.selectedDevice == '') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    if (this.selectedDevice == 'Select Device') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    try {
      this.spinner.show();
      this.DeviceService.ResetMachine(this.selectedDevice).subscribe(
        Response => {
          this.spinner.hide();

          if(Response.status==200)
          {
            this.noti.success('Success', 'Successfully Reset');
          }
          else
          {
            this.noti.error('Error', Response.body);
          }


      }, error => {
        this.spinner.hide();
        this.noti.success('Error', error.error);
      });
    } catch (error) {
      this.spinner.hide();
      this.noti.success('Error', 'Something Goes Wrong');
    }

  }

  UpdateDeviceName(devicaName: string) {
    console.log(devicaName);
    if (this.selectedDevice == '') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    if (this.selectedDevice == 'Select Device') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    if (devicaName == ''||devicaName == null) {
      this.noti.error('Error', 'Enter Device Name');
      return false;
    }
    this.spinner.show();


    if(devicaName.includes('&'))
    {
      let re = /\&/gi;

      devicaName =  devicaName.replace(re,'%26');
    }
    this.DeviceService.UpdateDeviceName(devicaName,this.selectedDevice).subscribe(
      Response => {
        this.spinner.hide();
       if(Response.status==200)
       {
        this.noti.success('Successfully Update', 'Success');
       }
      },
      error => {
        this.spinner.hide();
        this.noti.error('Error', 'error');
      }
    );
  }

  UpdateServerInfo(ServerIp: any, Port: string) {
    if (this.selectedDevice == '') {
      this.noti.error('Error', 'No Device Selected');
      return false;
    }
    this.spinner.show();
    this.DeviceService.UpdateServerInfo(this.selectedDevice, ServerIp, Port).subscribe(
      (next) => {
        this.spinner.hide();
        this.noti.success('Login Success', 'Successfully Login');

      },
      (error) => {
        this.spinner.hide();
        this.noti.success('Success', 'Successfully Updated');
      }
    );
  }

  LoadAllDevices() {
    this.spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    try {
    this.DeviceService.GetActiveDeviceList().subscribe(
      Response => {
        this.spinner.hide();
        if(Response.status==200)
        {
          this.Device=Response.body;
        }
        else
        {
        this.noti.error("Error",Response.body);
        }
      },
      err => {
        this.spinner.hide();
        this.noti.error("Error",err.error);
      }
   );
  } catch (error) {
    this.preloader.hide();
    this.noti.error("Error","Code Crashed");
  }
  }
}
